import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { SlideIn } from "@faire/retailer-visitor-shared/components/SlideIn";
import { useIsLoggedOutHomepageRedesignV2 } from "@faire/retailer-visitor-shared/settings/useSettingLoggedOutHomepageRedesignV2";
import { useAnimatedScroll } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/Animation/useAnimatedScroll";
import { PillWithContent } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/__internal__/PillWithContentComponent/PillWithContent";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useGetBrandValues } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/__internal__/useGetBrandValues";
import { BrandValueBanner } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBanner/BrandValueBanner";
import { BrandValueBannerBrandInfo } from "@faire/retailer-visitor-shared/views/home/logged-out-homepage/__internal__/components/BrandValueBannerV2/__internal__/BrandValueBannerBrandInfo";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { isRobot } from "@faire/web--source/common/user-agent/isRobot";
import { getSpacing } from "@faire/web--source/slate/spacing";
import * as React from "react";
export var BrandValueBannerWithV2Design = function() {
    var isHomepageRedesignV2 = useIsLoggedOutHomepageRedesignV2();
    if (isHomepageRedesignV2) {
        return /*#__PURE__*/ _jsx(BrandValueBannerV2, {});
    }
    return /*#__PURE__*/ _jsx(SlideIn, {
        offset: getSpacing("5x"),
        children: /*#__PURE__*/ _jsx(BrandValueBanner, {})
    });
};
var BrandValueBannerV2 = function() {
    var _brandValues_currentIndex;
    var brandValues = useGetBrandValues();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _brandValues_length;
    var _useAnimatedScroll = useAnimatedScroll((_brandValues_length = brandValues === null || brandValues === void 0 ? void 0 : brandValues.length) !== null && _brandValues_length !== void 0 ? _brandValues_length : 0, 5000), resumeScroll = _useAnimatedScroll.resumeScroll, pauseScroll = _useAnimatedScroll.pauseScroll, isVisible = _useAnimatedScroll.isVisible, currentIndex = _useAnimatedScroll.currentIndex, setCurrentIndex = _useAnimatedScroll.setCurrentIndex;
    var _brandValues_map;
    var tabs = (_brandValues_map = brandValues === null || brandValues === void 0 ? void 0 : brandValues.map(function(param) {
        var name = param.name, id = param.id;
        return {
            tabName: name,
            pathIdentifier: id,
            ctaLink: undefined,
            ctaLinkText: undefined
        };
    })) !== null && _brandValues_map !== void 0 ? _brandValues_map : [];
    return /*#__PURE__*/ _jsx(PillWithContent, {
        title: strictLocalize({
            id: "XFcmgY",
            defaultMessage: [
                {
                    type: 0,
                    value: "Shop by your values"
                }
            ]
        }),
        tabs: tabs,
        eventTrackingName: "brand_value_banner",
        pauseScroll: pauseScroll,
        resumeScroll: resumeScroll,
        currentIndex: currentIndex,
        setCurrentIndex: setCurrentIndex,
        isVisible: isVisible,
        children: isRobot() ? /*#__PURE__*/ _jsx(_Fragment, {
            children: brandValues.map(function(brandValue, index) {
                return /*#__PURE__*/ _jsx(BrandValueBannerBrandInfo, {
                    brandInfo: brandValue.brand,
                    className: index ? "invisible h-0 !p-0" : ""
                }, index);
            })
        }) : /*#__PURE__*/ _jsx(BrandValueBannerBrandInfo, {
            brandInfo: (_brandValues_currentIndex = brandValues[currentIndex]) === null || _brandValues_currentIndex === void 0 ? void 0 : _brandValues_currentIndex.brand
        })
    });
};
